export class SapStatusModel {
    status: string;
    remarks: string;
}


// WEBPACK FOOTER //
// ./src/models/order/sapstatus.model.ts